import { render, staticRenderFns } from "./BaseBannerInfo.vue?vue&type=template&id=2a01f601&scoped=true"
import script from "./BaseBannerInfo.vue?vue&type=script&lang=js"
export * from "./BaseBannerInfo.vue?vue&type=script&lang=js"
import style0 from "./BaseBannerInfo.vue?vue&type=style&index=0&id=2a01f601&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a01f601",
  null
  
)

export default component.exports